export const lockOrderState= {
    0: '已被取消',
    1: '锁仓成功,待下单',
    2: '等待同意',
    3: '超时失效',
    4: '锁仓被拒绝',
    5: '已转为下单'
}

export const liquidationState={
    1: '取消/关闭',
    2: '已发起清算,请填写退货数量',
    3: '退货数量通过，进入清算付款阶段',
    4: '供应商拒绝退货数量,请重新填写',
    5: '已发起退货,等待供应商审核',
    6: '清算完成'
}
export const liquidationStateShort={
    1: '取消/关闭',
    2: '请填写退货',
    3: '清算付款阶段',
    4: '退货数被拒绝',
    5: '退货数待审核',
    6: '清算完成'
}

